import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { ModelEmpty } from "site-apps/devices/DevicesModels";

const TabModel = ({ item, deviceModels }) => {
    const [modelData, setModelData] = useState({ ...ModelEmpty })

    const onChange = (e) => {
        let id = parseInt(e.target.value);
        id
            ? setModelData(deviceModels.find(model => model.id === id) || { ...ModelEmpty })
            : setModelData({ ...ModelEmpty });
    }

    useEffect(() => {
        if (item && item.model && deviceModels && deviceModels.length) {
            const foundModel = deviceModels.find(model => model.id == item.model);
            if (foundModel) {
                setModelData(foundModel);
            }
        }
    }, [item, deviceModels]);

    return <>
        <div className="row">
            <div className="col-md-3">
                <div className="text-md-end mt-2">
                    <label htmlFor="model" className="form-label">Model</label>
                </div>
            </div>
            <div className="col-md-6">
                <Form.Select className="mb-2" id="model" name="model"
                    onChange={onChange}
                    value={item.model || ""}
                    required
                >
                    <option value="">-</option>
                    {(deviceModels || []).map((model, index) => (
                        <option key={index} value={model.id} data-idx={index}>{model.name}</option>
                    ))}
                </Form.Select>
            </div>
        </div>

        <div className="row">
            <div className="col-md-3">
                <div className="text-md-end mt-2">
                    <label className="form-label">Version</label>
                </div>
            </div>
            <div className="col-md-6">
                <input type="text" className="form-control mb-2"
                    value={modelData.version || ""}
                    disabled={true}
                    readOnly={true}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-md-3">
                <div className="text-md-end mt-2">
                    <label className="form-label">Firmware</label>
                </div>
            </div>
            <div className="col-md-6">
                <input type="text" className="form-control mb-2"
                    value={modelData.firmware || ""}
                    disabled={true}
                    readOnly={true}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-md-3">
                <div className="text-md-end mt-2">
                    <label className="form-label">Provider</label>
                </div>
            </div>
            <div className="col-md-6">
                <input type="text" className="form-control mb-2"
                    value={modelData.provider || ""}
                    disabled={true}
                    readOnly={true}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-md-3">
                <div className="text-md-end mt-2">
                    <label className="form-label">Manufacturer</label>
                </div>
            </div>
            <div className="col-md-6">
                <input type="text" className="form-control mb-2"
                    value={modelData.manufacturer || ""}
                    disabled={true}
                    readOnly={true}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-md-3">
                <div className="text-md-end mt-2">
                    <label className="form-label">Type</label>
                </div>
            </div>
            <div className="col-md-6">
                <input type="text" className="form-control mb-2"
                    value={modelData.type || ""}
                    disabled={true}
                    readOnly={true}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-md-3">
                <div className="text-md-end mt-2">
                    <label className="form-label">Created at</label>
                </div>
            </div>
            <div className="col-md-3">
                <input type="text" className="form-control mb-2"
                    value={modelData.created_at || ""}
                    disabled={true}
                    readOnly={true}
                />
            </div>

            <div className="col-md-2">
                <div className="text-md-end mt-2">
                    <label className="form-label">Updated at</label>
                </div>
            </div>
            <div className="col-md-3">
                <input type="text" className="form-control mb-2"
                    value={modelData.updated_at || ""}
                    disabled={true}
                    readOnly={true}
                />
            </div>
        </div>

        <div className="row">
            <div className="col-md-3">
                <div className="text-md-end mt-2">
                    <label className="form-label">Description</label>
                </div>
            </div>
            <div className="col-md-8">
                <textarea className="form-control"
                    rows={4}
                    value={modelData.description || ""}
                    disabled={true}
                    readOnly={true}
                />
            </div>
        </div>
    </>
}

export default TabModel